import { Accordion } from 'flowbite-react';
const FintechFAQ: React.FC = () => {
    return (
        <>
            <Accordion>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        How Moweb fintech software development services help finance companies?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary">
                            We deliver scalable, compliant, and modern software solutions that automate finance processes, enhance
                            customer engagement, and improve operational efficiency across digital wallets, banking apps, and
                            investment platforms.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        Can you make sure that the finance apps are secure, and users&apos; data is taken care of?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary">
                            Yes. We follow best practices in cybersecurity, comply with financial regulations like PCI-DSS and
                            GDPR, and integrate encryption, tokenization, and secure APIs to protect user data and prevent fraud.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        Will the FinTech software be reliable enough?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary">
                            Our fintech software is built with enterprise-grade reliability in mind. We conduct rigorous testing,
                            ensure high availability architecture, and offer ongoing support to ensure consistent performance.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        How long does it take to build custom financial software development?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary">
                            Timelines vary based on features, tech stack, and integrations. Typically, a fully custom financial
                            app takes between 3 to 6 months from planning to release.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        Which technologies do you use for financial technology development?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary">
                            We work with technologies like React, Node.js, Python, .NET, Kotlin, Swift, AWS, Azure, blockchain
                            platforms, AI/ML libraries, and secure API protocols tailored to finance.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        How much does it cost to develop a fintech application?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary">
                            The cost to develop a fintech application typically ranges from $25,000 to over $150,000, depending on
                            features, security, and regulatory requirements. Each project is unique, so we offer tailored
                            estimates after understanding your goals. A quick scoping call can help you get a precise,
                            no-obligation quote.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        What is the process of fintech app development?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary">
                            Our process includes requirement analysis, UI/UX design, development in sprints, integration, QA, and
                            deployment—followed by support and enhancements to keep your app future-ready.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        How do I find the right fintech software development company?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary">
                            Look for proven experience, client testimonials, regulatory expertise, and a portfolio of
                            finance-specific apps. Moweb checks all the boxes—get in touch and evaluate us firsthand.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
            </Accordion>
        </>
    );
};

export default FintechFAQ;
